import { render, staticRenderFns } from "./OpportunityReview.vue?vue&type=template&id=5441b020&scoped=true&"
import script from "./OpportunityReview.vue?vue&type=script&lang=js&"
export * from "./OpportunityReview.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityReview.vue?vue&type=style&index=0&id=5441b020&prod&lang=css&"
import style1 from "./OpportunityReview.vue?vue&type=style&index=1&id=5441b020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5441b020",
  null
  
)

export default component.exports